module.exports = __webpack_public_path__ + "img/calendar-check-1.0d58c52c.svg";